export const range = (start, end) => {
  if (start > end) throw new Error('start cannot be greater than end');
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i + 1);
  }
  return result;
};
